exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section[data-v-15b2d97f]:not(:last-child) {\n  border-bottom: 1px solid #eee;\n}\n.vue-ui-dark-mode section[data-v-15b2d97f]:not(:last-child) {\n  border-bottom: 1px solid #141d25;\n}\n.component-name[data-v-15b2d97f] {\n  margin: 0 10px;\n}\n.string[data-v-15b2d97f] {\n  color: #c41a16;\n}\n.literal[data-v-15b2d97f] {\n  color: #03c;\n}\n.no-event-data[data-v-15b2d97f] {\n  color: #ccc;\n  text-align: center;\n  margin-top: 50px;\n  line-height: 30px;\n}\n", ""]);

// exports
